import { FirebaseError } from "@firebase/util";
import { AxiosError } from "axios";

import banks from "../utils/banks.json";
import { BusinessType } from "../services/queries/businesses/types";
import { UserRole } from "../services/queries/users/types";

export const routePaths = {
  login: "/login",
  signup: "/signup",
  forgotPassword: "/forgotPassword",
  resetPassword: "/resetPassword",
  users: "/users",
  send: "/send",
  dashboard: "/dashboard",
  collections: "/collections",
  sendReview: "/send/review",
  sendSuccess: "/send/success",
  beneficiary: "/send/beneficiary",
  sendConfirm: "/send/confirm",
  flights: "/flights",
  passengers: "/passengers",
  cards: "/cards",
  transactions: "/transactions",
  profile: "/profile",
};

export interface Route {
  path: string;
  title: string;
  slug: string;
  iconUrl?: string;
  isAppRoute: boolean;
  businessType?: BusinessType[];
  userRole?: UserRole[];
  showInSideNav?: boolean;
}

export const routes: Route[] = [
  {
    path: routePaths.login,
    slug: "login",
    title: "Login",
    isAppRoute: false,
  },
  {
    path: routePaths.dashboard,
    slug: "dashboard",
    title: "Dashboard",
    iconUrl: "/images/dashboard.png",
    isAppRoute: true,
    showInSideNav: true,
    businessType: [BusinessType.AGENCY, BusinessType.CORPORATE],
    userRole: [UserRole.ADMIN],
  },
  {
    path: routePaths.send,
    slug: "send",
    title: "Send Money",
    iconUrl: "/images/send.png",
    isAppRoute: true,
    showInSideNav: true,
    businessType: [BusinessType.AGENCY],
    userRole: [UserRole.ADMIN],
  },
  {
    path: routePaths.collections,
    slug: "collections",
    title: "Collections",
    iconUrl: "/images/send.png",
    isAppRoute: true,
    showInSideNav: true,
    businessType: [BusinessType.AGENCY],
    userRole: [UserRole.ADMIN],
  },
  {
    path: routePaths.transactions,
    slug: "transactions",
    title: "Transactions",
    iconUrl: "/images/transactions.png",
    isAppRoute: true,
    showInSideNav: true,
    businessType: [BusinessType.AGENCY, BusinessType.CORPORATE],
    userRole: [UserRole.ADMIN],
  },
  // {
  //   path: "/cards",
  //   slug: "cards",
  //   title: "Cards",
  //   iconUrl: "/images/cards.png",
  //   isAppRoute: true,
  //   showInSideNav: true,
  //   businessType: [BusinessType.AGENCY],
  //   userRole: [UserRole.ADMIN],
  // },
  {
    path: routePaths.passengers,
    slug: "passengers",
    title: "Passengers",
    iconUrl: "/images/users.png",
    isAppRoute: true,
    showInSideNav: true,
    businessType: [BusinessType.CORPORATE],
    userRole: [UserRole.ADMIN],
  },
  {
    path: routePaths.flights,
    slug: "flights",
    title: "Flights",
    iconUrl: "/images/flights.png",
    isAppRoute: true,
    showInSideNav: true,
    businessType: [BusinessType.CORPORATE],
    userRole: [UserRole.ADMIN],
  },
  // {
  //   path: "/visas",
  //   slug: "visas",
  //   title: "Visas",
  //   iconUrl: "/images/visas.png",
  //   isAppRoute: true,
  //   showInSideNav: true,
  //   businessType: [BusinessType.CORPORATE],
  //   userRole: [UserRole.ADMIN],
  // },
  // {
  //   path: "/accommodation",
  //   slug: "accommodation",
  //   title: "Accommodation",
  //   iconUrl: "/images/accommodation.png",
  //   isAppRoute: true,
  //   showInSideNav: true,
  //   businessType: [BusinessType.CORPORATE],
  //   userRole: [UserRole.ADMIN],
  // },
  {
    path: routePaths.users,
    slug: "users",
    title: "Users",
    iconUrl: "/images/users.png",
    isAppRoute: true,
    showInSideNav: true,
    businessType: [BusinessType.CORPORATE, BusinessType.AGENCY],
    userRole: [UserRole.ADMIN],
  },
  {
    path: routePaths.profile,
    slug: "profile",
    title: "Profile",
    isAppRoute: true,
    showInSideNav: false,
    businessType: [BusinessType.AGENCY, BusinessType.CORPORATE],
    userRole: [UserRole.ADMIN, UserRole.STAFF],
  },
  {
    path: routePaths.sendReview,
    slug: "send-review",
    title: "Review",
    isAppRoute: true,
    showInSideNav: false,
    businessType: [BusinessType.AGENCY],
    userRole: [UserRole.ADMIN],
  },
  {
    path: routePaths.sendConfirm,
    slug: "send-confirm",
    title: "Confirm",
    isAppRoute: true,
    showInSideNav: false,
    businessType: [BusinessType.AGENCY],
    userRole: [UserRole.ADMIN],
  },
  {
    path: routePaths.beneficiary,
    slug: "send-beneficiary",
    title: "Beneficiary",
    isAppRoute: true,
    showInSideNav: false,
    businessType: [BusinessType.AGENCY],
    userRole: [UserRole.ADMIN],
  },
  {
    path: routePaths.sendSuccess,
    slug: "send-success",
    title: "Success",
    isAppRoute: true,
    showInSideNav: false,
    businessType: [BusinessType.AGENCY],
    userRole: [UserRole.ADMIN],
  },
];

export const usersCollection = "users";

export const baseUrl = import.meta.env.VITE_SERVER_BASE_URL;
export const token = "token";
export const refreshToken = "refreshToken";

// localStorage keys owned by the auth session. Logout must clear exactly
// these — never localStorage.clear(), which would wipe unrelated UI prefs.
export const AUTH_STORAGE_KEYS = ["user", "business"] as const;

export const Terms =
  "https://passportmonie.notion.site/Terms-and-Conditions-a2a4f5f38e424baba70f31345b8cda39";
export const PrivacyPolicy =
  "https://passportmonie.notion.site/Privacy-Policy-56f4825897154b4285ab5abd3fd02db6";

export const currencies = [
  { value: "NGN", label: "🇳🇬 NGN" },
  { value: "KES", label: "🇰🇪 KES" },
  { value: "GHS", label: "🇬🇭 GHS" },
  { value: "RWF", label: "🇷🇼 RWF" },
  { value: "TZS", label: "🇹🇿 TZS" },
  { value: "UGX", label: "🇺🇬 UGX" },
  { value: "XOF", label: "🇨🇮 XOF" },
];

export const recipientType = [
  { value: "Business", label: "Business" },
  { value: "Individual", label: "Individual" },
];

export const paymentMethod = [
  { value: "BANK", label: "Bank" },
  { value: "MOBILE_MONEY", label: "Mobile Money" },
];

export const reason = [
  { value: "Trade", label: "Trade" },
  { value: "Salary", label: "Salary" },
  { value: "Gifts and donations", label: "Gifts and donations" },
  { value: "Others", label: "Others" },
];

export const firebaseCodes = {
  wrongPassword: "auth/wrong-password",
  noUser: "auth/user-not-found",
  emailExists: "auth/email-already-in-use",
  networkError: "auth/network-request-failed",
};

export const errorMessages = {
  invalidLogin: "Incorrect Login details",
  emailExists: "Email registered already",
  notBusinessUser: "Sorry you’re not allowed to access this resource",
  networkError:
    "Network Connection error. Pls check your connection and ty again",
};

export const getAuthErrorMessage = (error: unknown): string => {
  if (error instanceof FirebaseError) {
    switch (error.code) {
      case firebaseCodes.noUser:
      case firebaseCodes.wrongPassword:
        return errorMessages.invalidLogin;

      case firebaseCodes.emailExists:
        return errorMessages.emailExists;

      case firebaseCodes.networkError:
        return errorMessages.networkError;

      default:
        return error.message;
    }
  }

  if (error instanceof AxiosError) {
    return error.response?.data.message;
  }

  return "An error occured. Please try again later.";
};

const bankData = banks.data.map((bank) => ({
  value: bank.slug,
  label: bank.name,
}));

export enum PaymentMethod {
  MPESA = "MPESA",
  BANK = "BANK",
  MTN = "MTN MOBILE MONEY",
  WAVE = "WAVE",
  ORANGE_MONEY = "ORANGE MONEY",
  MOOV = "MOOV",
  MOBILE_MONEY = "MOBILE MONEY",
}

export enum Currency {
  NGN = "NGN",
  KES = "KES",
  GHS = "GHS",
  USD = "USD",
  ZAR = "ZAR",
  UGX = "UGX",
  TZS = "TZS",
  XOF = "XOF",
  RWF = "RWF",
}

export enum RecipientType {
  INDIVIDUAL = "INDIVIDUAL",
  BUSINESS = "BUSINESS",
}

export enum TransactionStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
}

export const currencyDetails = [
  { currency: "NGN", canSend: currencies.slice(1), paymentMethods: bankData },
  {
    currency: "KES",
    canSend: [{ value: "NGN", label: "🇳🇬 NGN" }],
    paymentMethods: [
      { value: PaymentMethod.MPESA, label: PaymentMethod.MPESA },
    ],
  },
  {
    currency: "GHS",
    canSend: [{ value: "NGN", label: "🇳🇬 NGN" }],
    paymentMethods: [{ value: PaymentMethod.MTN, label: PaymentMethod.MTN }],
  },
  {
    currency: "RWF",
    canSend: [{ value: "NGN", label: "🇳🇬 NGN" }],
    paymentMethods: [{ value: PaymentMethod.MTN, label: PaymentMethod.MTN }],
  },
  {
    currency: "TZS",
    canSend: [{ value: "NGN", label: "🇳🇬 NGN" }],
    paymentMethods: [
      { value: PaymentMethod.MPESA, label: PaymentMethod.MPESA },
    ],
  },
  {
    currency: "UGX",
    canSend: [{ value: "NGN", label: "🇳🇬 NGN" }],
    paymentMethods: [{ value: PaymentMethod.MTN, label: PaymentMethod.MTN }],
  },
  {
    currency: "XOF",
    canSend: [{ value: "NGN", label: "🇳🇬 NGN" }],
    paymentMethods: [
      { value: PaymentMethod.MTN, label: PaymentMethod.MTN },
      { value: PaymentMethod.WAVE, label: PaymentMethod.WAVE },
      { value: PaymentMethod.ORANGE_MONEY, label: PaymentMethod.ORANGE_MONEY },
      { value: PaymentMethod.MOOV, label: PaymentMethod.MOOV },
    ],
  },
];

export const paymentDetails = [
  {
    currency: "NGN",
    institution: "Providus Bank",
    accountName: "PAZZPORT TECHNO. SOLUTIONS LTD",
    accountNumber: "1305126224",
  },
];

export const paymentMethodLabels = {
  NGN: {
    accountNumber: "Account Number",
    accountName: "Account Name",
    institution: "Institution",
  },
  KES: {},
  GHS: {},
  USD: {},
  ZAR: {},
  UGX: {},
  TZS: {},
};

export enum ApiRoutes {
  BUSINESS_ORDERS = "/businesses-orders",
  RATES = "/rates",
  VIRTUAL_TERMINAL = "/virtual-terminals/me",
  VIRTUAL_ACCOUNTS = "/business-virtual-accounts/me",
  LOGIN = "/auth/business/login",
  SIGNUP = "/auth/business/signup",
  LOGOUT = "/auth/business/logout",
  REFRESH_TOKEN = "/auth/business/refresh",
  FORGOT_PASSWORD = "/auth/business/forgot-password",
  ENCRYPTION_KEY = "/encryption/public-key",
}

export const labels = {
  paidText: "I have paid",
  copy: "Copy",
  copied: "Copied",
  continue: "Continue",
  youSend: "You send",
  submit: "Submit",
  payIntoAccount: "Please pay into this account",
  amountToSend: "Amount to send",
  recipientGets: "Recipients gets",
  transferDetails: "Transfer Details",
  recipientDetails: "Recipient Details",
  accountName: "Account Name",
  accountNumber: "Account Number",
  institutionOrBank: "Institution/Bank",
  paymentMethod: "Payment Method",
  selectPaymentMethod: "Select Payment Method",
  enterAccountName: "Enter Account Name",
  enterAccountNumber: "Enter Account Number",
  enterInstitutionOrBank: "Enter Institution/Bank",
};

export enum WithdrawalType {
  INTERNATIONAL = "INTERNATIONAL",
  LOCAL = "LOCAL",
}

export enum BeneficiaryType {
  PERSONAL = "PERSONAL",
  BUSINESS = "BUSINESS",
}

export const currenciesConfig = [
  {
    currency: Currency.NGN,
    canSend: [
      { value: Currency.KES, label: `🇰🇪 ${Currency.KES}` },
      { value: Currency.GHS, label: `🇬🇭 ${Currency.GHS}` },
      { value: Currency.ZAR, label: `🇿🇦 ${Currency.ZAR}` },
      { value: Currency.UGX, label: `🇺🇬 ${Currency.UGX}` },
      { value: Currency.TZS, label: `🇹🇿 ${Currency.TZS}` },
    ],
    paymentMethods: [
      {
        value: PaymentMethod.BANK,
        label: PaymentMethod.BANK,
        minLength: 10, // Nigerian bank accounts are exactly 10 digits
        maxLength: 10,
        canResolveAccountName: true,
      },
    ],
    countryCode: "NG",
    diallingCode: "234",
  },
  {
    currency: Currency.KES,
    canSend: [],
    paymentMethods: [
      {
        value: PaymentMethod.MOBILE_MONEY,
        label: PaymentMethod.MOBILE_MONEY,
        minLength: 10,
        maxLength: 10, // Kenyan mobile money accounts are typically 10 digits
        canResolveAccountName: false,
      },
      {
        value: PaymentMethod.BANK,
        label: PaymentMethod.BANK,
        minLength: 8,
        maxLength: 12, // Kenyan bank accounts can be 8-12 digits
        canResolveAccountName: false,
      },
    ],
    countryCode: "KE",
    diallingCode: "254",
  },
  {
    currency: Currency.GHS,
    canSend: [],
    paymentMethods: [
      {
        value: PaymentMethod.MOBILE_MONEY,
        label: PaymentMethod.MOBILE_MONEY,
        minLength: 10,
        maxLength: 10, // Ghanaian mobile money accounts are typically 10 digits
        canResolveAccountName: false,
      },
      {
        value: PaymentMethod.BANK,
        label: PaymentMethod.BANK,
        minLength: 13,
        maxLength: 14, // Ghanaian bank accounts are 13-14 digits
        canResolveAccountName: false,
      },
    ],
    countryCode: "GH",
    diallingCode: "233",
  },
  {
    currency: Currency.UGX,
    canSend: [],
    paymentMethods: [
      {
        value: PaymentMethod.MOBILE_MONEY,
        label: PaymentMethod.MOBILE_MONEY,
        minLength: 10,
        maxLength: 11, // Ugandan mobile money accounts are 10-11 digits
        canResolveAccountName: false,
      },
      // {
      //   value: PaymentMethod.BANK,
      //   label: PaymentMethod.BANK,
      //   maxLength: 12, // Ugandan bank accounts can be up to 12 digits
      //   canResolveAccountName: false,
      // }
    ],
    countryCode: "UG",
    diallingCode: "256",
  },
  {
    currency: Currency.ZAR,
    canSend: [],
    paymentMethods: [
      {
        value: PaymentMethod.BANK,
        label: PaymentMethod.BANK,
        minLength: 9,
        maxLength: 12, // South African bank accounts are 9-12 digits
        canResolveAccountName: false,
      },
    ],
    countryCode: "ZA",
    diallingCode: "27",
  },
  {
    currency: Currency.TZS,
    canSend: [],
    paymentMethods: [
      {
        value: PaymentMethod.MOBILE_MONEY,
        label: PaymentMethod.MOBILE_MONEY,
        minLength: 10,
        maxLength: 11, // Tanzanian mobile money accounts are 10-11 digits
        canResolveAccountName: false,
      },
    ],
    countryCode: "TZ",
    diallingCode: "255",
  },
];
